<template>
    <div
        :data-component-name="$options.name"
    >
        <div v-bind:key="index" v-for="(tag, index) in tags">
            <q-chip removable @remove="tags.splice(index, 1)" :color="color" text-color="white" size="sm">
                {{ tag.name }}
            </q-chip>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'CoursesList',
        props: [
            "tags",
            "color"
        ],
        data(){
            return {

            }
        },
        computed: {
        }
    }
</script>
